import React, { Component } from 'react';

class TextareaExpanding extends Component {
  constructor(props) {
    super(props);
    this.textarea = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      const currentTextarea = this.textarea.current;
      const minHeight = currentTextarea.minHeight || 36;
      if (this.props.value === null || this.props.value.length === 0) {
        currentTextarea.style.height = `${minHeight}px`;
        return;
      }
      const newHeight = currentTextarea.scrollHeight > minHeight
        ? currentTextarea.scrollHeight : minHeight;
      currentTextarea.style.height = `${newHeight + 2}px`;
    }
  }

  _handleChange = (e) => {
    if (e.target.value.length === 0) {
      e.target.style.height = 'auto';
    }
    const minHeight = e.target.minHeight || 36;
    e.target.style.height = `${e.target.scrollHeight > minHeight ? e.target.scrollHeight : minHeight}px`;
  }

  render() {
    const { ...rest } = this.props;
    return (
      <textarea
        ref={this.textarea} {...rest}
        style={{ resize: 'vertical' }}
      />
    );
  }
}

export default TextareaExpanding;
